import React, {Component} from 'react';
import {gpn} from "../GPN"
import {Route, Routes} from "react-router-dom";
import config from "../config";
import axios from "axios";
import SideBar from "../sections/SideBar";
import {toast} from "react-toastify";
import Login from "./Login";
import Init from "./Init";
import Dashboard from "./Dashboard";
import Icon from "../sections/MUI/Icon";
import Settings from "./Settings";
import Users from "./user/Users";
import User from "./user/User";
import Facilities from "./Facilities";
import Services from "./Services";
import Orders from "./Orders";
import Payments from "./Payments";
import Admins from "./Admins";
import PrintContract from "./PrintContract";
import Gateway from "./Gateway";
import Services2 from "./Services2";
import SMS from "./SMS";
import Storages from "./Storages";
import Estelam from "./Estelam";
import BlackList from "./BlackList";
import Logs from "./Logs";
import MajidPoorsant from "./MajidPoorsant";
import AzarPM from "./AzarPM";

class App extends Component {

    state = {
        firstName: "",
        lastName: "",
        permissions: [],
        phoneNumber: ""
    };

    componentDidMount() {
        if (config.token === "" && document.location.pathname !== "/login" && document.location.pathname !== "/init") {
            document.location.href = "/login";
        } else {
            this.getInfo()
        }
    }

    isLoginPage() {
        return document.location.pathname === "/login" || document.location.pathname === "/init"
    }

    getInfo() {
        axios.get(`${config.api}/admin/info?token=${config.token}`)
            .then(r => {
                this.setState({
                    ...r.data
                });
            })
            .catch(err => {
                let error = config.handleError(err);
                if (error.includes("دسترسی") && document.location.pathname !== "/login" && document.location.pathname !== "/init") {
                    document.location.href = "/login";
                }
            });
    }

    render() {
        const {firstName, lastName, permissions, phoneNumber} = this.state;
        const {navigate} = this.props;
        const ro = {
            navigate,
            firstName,
            lastName,
            permissions,
            phoneNumber
        };

        return (

            <div className="row">
                {
                    !this.isLoginPage() ?
                        <SideBar {...ro}/>
                        : null
                }
                <div className={this.isLoginPage() ? "col-12" : "col-md"}>
                    {
                        !this.isLoginPage() ?
                            <header>
                                <p>سلام&nbsp;{firstName}&nbsp;{lastName}&nbsp;عزیز؛ به پنل مدیریت خوش آمدید&nbsp;<Icon
                                    i="person-from-portal" onClick={() => {
                                    localStorage.removeItem("token");
                                    toast.success("در حال خروج ...");
                                    setTimeout(() => {
                                        document.location.href = "/login";
                                    }, 2000)
                                }}/></p>
                            </header> : null
                    }

                    <main>
                        <Routes>
                            <Route path="/login" element={<Login {...ro}/>}/>
                            <Route path="/init" element={<Init {...ro}/>}/>
                            {config.hasAccess(permissions, "sms") ?
                                <>
                                    <Route path="/sms" element={<SMS {...ro}/>}/>
                                </>
                                : null}
                            {config.hasAccess(permissions, "dashboard") ?
                                <>
                                    <Route path="/" element={<Dashboard {...ro}/>}/>
                                </>
                                : null}
                            {config.hasAccess(permissions, "settings") ?
                                <>
                                    <Route path="/settings" element={<Settings {...ro}/>}/>
                                    <Route path="/logs" element={<Logs {...ro}/>}/>
                                </>
                                : null}

                            {config.hasAccess(permissions, "users") ?
                                <>
                                    <Route path="/users" element={<Users {...ro}/>}/>
                                    <Route path="/user/:id" element={<User {...ro}/>}/>
                                    <Route path="/user/contract/:id" element={<PrintContract {...ro}/>}/>
                                </>
                                : null}
                            {config.hasAccess(permissions, "facilities") ?
                                <>
                                    <Route path="/facilities" element={<Facilities {...ro}/>}/>
                                </>
                                : null}
                            {config.hasAccess(permissions, "services") ?
                                <>
                                    <Route path="/services" element={<Services {...ro}/>}/>
                                    <Route path="/services2" element={<Services2 {...ro}/>}/>
                                </>
                                : null}
                            {config.hasAccess(permissions, "orders") ?
                                <>
                                    <Route path="/orders" element={<Orders {...ro}/>}/>
                                </>
                                : null}
                            {config.hasAccess(permissions, "payments") ?
                                <>
                                    <Route path="/payments" element={<Payments {...ro}/>}/>
                                </>
                                : null}
                            {config.hasAccess(permissions, "admins") ?
                                <>
                                    <Route path="/admins" element={<Admins {...ro}/>}/>
                                </>
                                : null}
                            {config.hasAccess(permissions, "gateway") ?
                                <>
                                    <Route path="/gateway" element={<Gateway {...ro}/>}/>
                                </>
                                : null}

                            {config.hasAccess(permissions, "storage") ?
                                <>
                                    <Route path="/storage" element={<Storages {...ro}/>}/>
                                </>
                                : null}

                            {config.hasAccess(permissions, "estelam") ?
                                <>
                                    <Route path="/estelam" element={<Estelam {...ro}/>}/>
                                </>
                                : null}

                            {config.hasAccess(permissions, "blacklist") ?
                                <>
                                    <Route path="/black-list" element={<BlackList {...ro}/>}/>
                                </>
                                : null}


                            <Route path="/poorsant" element={<MajidPoorsant {...ro}/>}/>
                            {
                                phoneNumber?.toString() === "09900152885" ?
                                    <Route path="/azar-pm" element={<AzarPM {...ro}/>}/>
                                    : null
                            }
                        </Routes>
                    </main>

                </div>

            </div>
        );
    }
}

export default gpn(App);